export const appian = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 32,
  inputPaddingInline: 0,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 17,
  inputFontFamily: '"Effra", sans-serif',
  inputColor: "#000F54",
  inputBackgroundColor: "transparent",
  inputFontWeight: 400,

  inputBorderColor: "#000F54",
  inputBorderWidth: 2,
  inputBorderRadius: 0,

  inputHoverColor: "#000F54",
  inputHoverBorderColor: "#000F54",
  inputHoverBackgroundColor: "transparent",

  // **********************************
  //  Select field
  selectTopSpacing: 32,
  selectPaddingInline: 0,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 17,
  selectFontFamily: '"Effra", sans-serif',
  selectColor: "#000F54",
  selectBackgroundColor: "transparent",
  selectFontWeight: 400,

  selectBorderColor: "#000F54",
  selectBorderWidth: 2,
  selectBorderRadius: 0,

  selectHoverColor: "#000F54",
  selectHoverBorderColor: "#000F54",
  selectHoverBackgroundColor: "transparent",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 32,
  textAreaPaddingInline: 0,

  textAreaHeight: 45,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 17,
  textAreaFontFamily: '"Effra", sans-serif',
  textAreaColor: "#000F54",
  textAreaBackgroundColor: "transparent",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#000F54",
  textAreaBorderWidth: 2,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#000F54",
  textAreaHoverBorderColor: "#000F54",
  textAreaHoverBackgroundColor: "transparent",

  // **********************************
  //  placeholder
  placeholderColor: "#000F54",
  placeholderFontFamily: '"Effra", sans-serif',
  placeholderFontSize: 17,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#000F54",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 6,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 17,
  fieldLabelColor: "#000F54",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#000F54",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Effra", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#666666",
  descriptionFontSize: 13,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Effra", sans-serif',
  descriptionTopSpacing: 5,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 30,
  checkboxBorderWidth: 2,
  checkboxBorderRadius: 3,
  checkboxUncheckedBorderColor: "#707070",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#1E3DF0",
  checkboxCheckedBorderColor: "#707070",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Effra", sans-serif',
  checkboxLabelFontSize: 17,
  checkboxLabelFontWeight: 700,
  checkboxLabelColor: "#000000",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 30,
  radioBorderWidth: 2,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#707070",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#1E3DF0",
  radioCheckedBorderColor: "#707070",

  radioAlignment: "none",

  radioLabelFontFamily: '"Effra", sans-serif',
  radioLabelFontSize: 17,
  radioLabelFontWeight: 700,
  radioLabelColor: "#000",

  // **********************************
    // toggle

    toggleLabelFontFamily: '"Effra", sans-serif',
    toggleLabelFontSize: 17,
    toggleLabelFontWeight: 700,
    toggleLabelColor: "#000000",
  
    // **********************************
  // submit button

  submitMarginTop: 36,
  submitFontSize: 20,
  submitFontFamily: "'Effra', sans-serif",
  submitWidth: 100,
  submitWidthUnits: "%",
  submitHeight: 41,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#1E3DF0",
  submitColor: "#fff",
  submitBorderColor: "#1E3DF0",
  submitBackgroundHover: "#1E3DF0",
  submitBorderColorHover: "#1E3DF0",
  submitColorHover: "#fff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  